import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowMove = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 192,
	height: 192,
	viewBox: "0 0 256 256",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 256,
			height: 256,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "156.3 203.7 128 232 99.7 203.7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 128,
			y1: 160,
			x2: 128,
			y2: 232,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "99.7 52.3 128 24 156.3 52.3",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 128,
			y1: 96,
			x2: 128,
			y2: 24,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "52.3 156.3 24 128 52.3 99.7",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 96,
			y1: 128,
			x2: 24,
			y2: 128,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "203.7 99.7 232 128 203.7 156.3",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 160,
			y1: 128,
			x2: 232,
			y2: 128,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 8
		})
	]
});
export default SvgArrowMove;
